/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { EnumerationEvaluationParameterDto } from './EnumerationEvaluationParameterDto';
import {
    instanceOfEnumerationEvaluationParameterDto,
    EnumerationEvaluationParameterDtoFromJSON,
    EnumerationEvaluationParameterDtoFromJSONTyped,
    EnumerationEvaluationParameterDtoToJSON,
} from './EnumerationEvaluationParameterDto';
import type { NumericEvaluationParameterDto } from './NumericEvaluationParameterDto';
import {
    instanceOfNumericEvaluationParameterDto,
    NumericEvaluationParameterDtoFromJSON,
    NumericEvaluationParameterDtoFromJSONTyped,
    NumericEvaluationParameterDtoToJSON,
} from './NumericEvaluationParameterDto';

/**
 * @type EvaluationParameterDto
 * 
 * @export
 */
export type EvaluationParameterDto = { $type?: 'Ptw.Ptw100.AppZero.Application.Shared.TaskItemComponent.Dto.EvaluationParameters.EnumerationEvaluationParameterDto, Ptw.Ptw100.AppZero.Application.Shared' } & EnumerationEvaluationParameterDto | { $type?: 'Ptw.Ptw100.AppZero.Application.Shared.TaskItemComponent.Dto.EvaluationParameters.NumericEvaluationParameterDto, Ptw.Ptw100.AppZero.Application.Shared' } & NumericEvaluationParameterDto;


export function EvaluationParameterDtoFromJSON(json: any): EvaluationParameterDto {
    return EvaluationParameterDtoFromJSONTyped(json, false);
}

export function EvaluationParameterDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): EvaluationParameterDto {
    if (json == null) {
        return json;
    }
    switch (json['$type']) {
        case 'Ptw.Ptw100.AppZero.Application.Shared.TaskItemComponent.Dto.EvaluationParameters.EnumerationEvaluationParameterDto, Ptw.Ptw100.AppZero.Application.Shared':
            return Object.assign({}, EnumerationEvaluationParameterDtoFromJSONTyped(json, true), { $type: 'Ptw.Ptw100.AppZero.Application.Shared.TaskItemComponent.Dto.EvaluationParameters.EnumerationEvaluationParameterDto, Ptw.Ptw100.AppZero.Application.Shared' } as const);
        case 'Ptw.Ptw100.AppZero.Application.Shared.TaskItemComponent.Dto.EvaluationParameters.NumericEvaluationParameterDto, Ptw.Ptw100.AppZero.Application.Shared':
            return Object.assign({}, NumericEvaluationParameterDtoFromJSONTyped(json, true), { $type: 'Ptw.Ptw100.AppZero.Application.Shared.TaskItemComponent.Dto.EvaluationParameters.NumericEvaluationParameterDto, Ptw.Ptw100.AppZero.Application.Shared' } as const);
        default:
            throw new Error(`No variant of EvaluationParameterDto exists with '$type=${json['$type']}'`);
    }
}

export function EvaluationParameterDtoToJSON(value?: EvaluationParameterDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    switch (value['$type']) {
        case 'Ptw.Ptw100.AppZero.Application.Shared.TaskItemComponent.Dto.EvaluationParameters.EnumerationEvaluationParameterDto, Ptw.Ptw100.AppZero.Application.Shared':
            return EnumerationEvaluationParameterDtoToJSON(value);
        case 'Ptw.Ptw100.AppZero.Application.Shared.TaskItemComponent.Dto.EvaluationParameters.NumericEvaluationParameterDto, Ptw.Ptw100.AppZero.Application.Shared':
            return NumericEvaluationParameterDtoToJSON(value);
        default:
            throw new Error(`No variant of EvaluationParameterDto exists with '$type=${value['$type']}'`);
    }

}

/**
 * Check if a given object implements the EvaluationParameterDto interface.
 */
export function instanceOfEvaluationParameterDto(value: any): value is EvaluationParameterDto {
    if (instanceOfEnumerationEvaluationParameterDto(value)) return true;
    if (instanceOfNumericEvaluationParameterDto(value)) return true;
    return false;
}

